<template>
    <div class="page-center content-load fadeIn animated">
        <span class="selo">
            <i class="material-icons">check_circle</i>
            Você está em um ambiente seguro.
        </span>
        <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide>
                <div class="swiper-layer"></div>
                <center>
                    <img src="static/images/logo.png" width="90%" class="logo animated fadeIn slower">
                </center>                
                <br>
                <br>
                <p class="animated fadeIn slower">
                    Bem vindo(a) a uma nova maneira de <b>viver</b> a vida..
                </p>
                <br>
                <a class="button animated fadeIn slower" v-on:click="next()">
                    Prosseguir
                    <i class="material-icons">arrow_forward</i>
                </a>
            </swiper-slide>
            <swiper-slide>
                <div class="swiper-layer"></div>
                <center>
                    <img src="static/images/logo1.png" style="width: 150px;" class="logo">
                </center>                                
                <p>
                    Transformando recomeços<br>em <b>grandes histórias</b>.
                </p>
                <br>
                <a class="button " v-on:click="next()">
                    Prosseguir
                    <i class="material-icons">arrow_forward</i>
                </a>
            </swiper-slide>
            <swiper-slide>
                <div class="swiper-layer"></div>
                <center>
                    <img src="static/images/logo3.png" style="width: 140px;" class="logo">
                </center>                
                <br>                
                <p style="text-align: left; font-size: 50px; line-height: 120%;">
                    <b style="color: #00a465">#</b><b style="color: #fd45af">unidos</b><br>
                    <b style="color: #03c5f0">pela</b><br>
                    <b style="color: #dc9e00">vida</b>
                </p>
                <br>
<!--                 <router-link :to="{'name': 'Login'}" class="button ">
                    Prosseguir
                    <i class="material-icons">arrow_forward</i>
                </router-link> -->

                <a class="button " v-on:click="next()">
                    Prosseguir
                    <i class="material-icons">arrow_forward</i>
                </a>                
            </swiper-slide>
            <swiper-slide>
                <div class="swiper-layer"></div>
                <center>
                    <img src="/static/images/logo4.png" class="logo-sidebar" style="width: 70%; margin-top: -6rem;">
                </center>
                <p>
                    Como deseja prosseguir?
                </p>
                <br>
<!--                 <router-link :to="{'name': 'Login'}" class="button ">
                    Prosseguir
                    <i class="material-icons">arrow_forward</i>
                </router-link> -->

                <router-link :to="{'name': 'Dashboard'}" class="button " style="bottom: 170px;">
                    Prosseguir sem cadastro
                    <i class="material-icons">arrow_forward</i>
                </router-link>
                <router-link :to="{'name': 'Login'}" class="button color-secondary" style="bottom: 110px;">
                    <i class="material-icons">account_circle</i>
                    Fazer login
                </router-link>
                <router-link :to="{'name': 'Cadastro'}" class="button color-primary">
                    <i class="material-icons">person_add</i>
                    Cadastrar
                </router-link>                    
            </swiper-slide>            
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>                                                       

    </div>      
</template>

<script>
export default {
    name: 'Intro',
    data () {
        return {
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            etapa:      0,            
        }
    },
    methods: {
        next: function() {
            var self = this;
            console.log("next()");
            self.etapa++;
            self.$refs.mySwiper.swiper.slideNext()
            if (self.etapa == 3) {
                console.log("Seta localStorage _intro");
                window.localStorage.setItem("_intro", true);
            }
        },
        prosseguir: function() {
            var self = this;

        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    created() {
        loading.show();
    },
    mounted() {
        var self = this
        
        if (window.localStorage.getItem("_intro")) {
            self.$refs.mySwiper.swiper.slideTo(3, 0, false)
        }
        setTimeout(function() {
            loading.hide();
        }, 100);
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .swiper-container {
      width: 100%;
      height: 100%;
    }

    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }    
    .current-page-introducao .loading {
        top: 0px !important;
    }
    .page-introducao #wrapper {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
    .page-introducao .container {
        padding-left: 20px;
        padding-right: 20px;
    }
    .logo {
        width: 80%;
        margin-bottom: 5vh;
    }
    .page-introducao p {
        z-index: 2;
        color: #333;
        font-size: 1.2em;
        line-height: 130%;
        padding-left: 10%;
        padding-right: 10%;
    }
    .page-introducao .button i {
        font-size: 14px;
        top: 2px;
    }
    .page-introducao .button {
        position: absolute;
        bottom: 50px;
        top: auto;
        /*border: none;*/
        border-color: #59ba92;
        background: #fff;
        color: #333;
        left: 40px;
        right: 40px;
        width: auto;
        /*width: 80%;*/
    }
    .page-introducao .swiper-container {
        height: 100vh;
        background-image: url(/static/images/img1.jpg);
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .page-introducao .swiper-slide {
        flex-direction: column;
        background: transparent;
    }
    .page-introducao .swiper-layer {
        position: absolute;
        left: 0px;
        right: 0px;
        z-index: 0;
        top: 0px;
        bottom: 0px;
        background: #FFF;
        opacity: 0.9;
    }
    .page-introducao .logo, .page-introducao center {
        z-index: 1;
    }
    .page-introducao .swiper-pagination-bullet-active {
        background: #59ba92 !important;
    }

    .page-introducao #wrapper {
        display: block !important;
    }

    .page-introducao .selo {
        /*position: absolute;*/
        top: 5px;
        width: 100%;
        position: fixed;
        line-height: 100%;
        z-index: 999;
        display: block;
        margin-top: 5px;
        text-transform: uppercase;
        font-size: 10px;
        text-align: center;
        letter-spacing: 0px;
        color: #444;
        opacity: 0.6;
    }
    .page-introducao .selo i {
        font-size: 14px;
        top: 2px;
        color: #59ba92;
        position: relative;
    }    
    /*.button {
        border-color: inherit;
    } */
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue